module.exports = __webpack_public_path__ + "static/media/Group 1505@3x.35125c86.png";